"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateLeft;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function calculateLeft(_ref) {
  var value = _ref.value,
      start = _ref.start,
      end = _ref.end,
      width = _ref.width,
      pointerWidth = _ref.pointerWidth;

  var _ref2 = value || [],
      _ref3 = (0, _slicedToArray2["default"])(_ref2, 1),
      from = _ref3[0],
      scale = end - start,
      pointersWidth = (0, _pixelToNumber["default"])(pointerWidth) * 2;

  var left = isNaN(from) || from < start ? 0 : (from - start) / scale * 100;
  var widthRest = width - width / 100 * left; // both pointers near right border
  // need to reserve space between border and left offset

  left = widthRest < pointersWidth ? "calc(".concat(left, "% - ").concat(pointersWidth - widthRest, "px)") : "".concat(left, "%");
  return left;
}